import { Code, Flex, Heading, Image } from '@chakra-ui/react'
import React from 'react'
import { ScrollView } from '../../layouts/PageWrap/styles'
import images from '../../theme/images'

type FallbackErrorMessageProps = {
  message?: string
}
const FallbackErrorMessage: React.FC<FallbackErrorMessageProps> = (props) => (
  <ScrollView>
    <Flex flex={1} flexDirection="column" justifyContent="center" alignItems="center">
      <Image src={images.warning} width={350} height={350} />
      <Heading textAlign="center" size="md" mt={4} fontWeight="lighter">
        An error has occurred.
      </Heading>
      {props.message && <Code variantColor="red" children={props.message} />}
    </Flex>
  </ScrollView>
)

export default FallbackErrorMessage
